import { Button } from "@mui/material";


export default function ButtonForgotPassword({...props}) {
  return (
    <Button 
    {...props}
    color="blueSys"
      sx={{ textTransform: 'initial',paddingLeft:"0.5px" }}
    >
      Esqueceu a senha?
    </Button>
  );
}
